const MessageTypes = {
  SUCCESS: "Success",
  ERROR: "Error",
  INFO: "Info",
  CHEERS: "Cheers"
}
export default MessageTypes;
